export enum PaymentConstants {
    payment = 'payment'
}